const footerDataCollections = [
  [
    {
      title: "Shop and learn",
      links: [
        { text: "Mac", URL: "https://www.apple.com/mac/" },
        { text: "iPad", URL: "https://www.apple.com/ipad/" },
        { text: "iPhone", URL: "https://www.apple.com/iphone/" },
        { text: "Watch", URL: "https://www.apple.com/watch/" },
        { text: "TV", URL: "" },
        { text: "Music", URL: "https://www.apple.com/Music/" },
        { text: "Airpods", URL: "https://www.apple.com/airpods/" },
        { text: "Homepod", URL: "#" },
        { text: "Mac", URL: "#" },
        { text: "iPod touch", URL: "#" },
        { text: "Accessories", URL: "#" },
        { text: "Gift cards", URL: "#" },
      ],
    },
  ],
  [
    {
      title: "Services",
      links: [
        { text: "Apple Music", URL: "#" },
        { text: "Apple News", URL: "#" },
        { text: "Apple TV+", URL: "#" },
        { text: "Apple Arcade", URL: "#" },
        { text: "Apple Card", URL: "#" },
        { text: "iCloud", URL: "#" },
      ],
    },
    {
      title: "Account",
      links: [
        { text: "Manage Your Apple ID", URL: "#" },
        { text: "Apple Store Account", URL: "#" },
        { text: "iCloud.com", URL: "#" },
      ],
    },
  ],
  [
    {
      title: "Apple Store",
      links: [
        { text: "Find a Store", URL: "https://www.apple.com/store" },
        { text: "Genius Bar", URL: "#" },
        { text: "Today at Apple+", URL: "#" },
        { text: "Apple Camp", URL: "#" },
        { text: "Field Trip", URL: "#" },
        { text: "iCloud", URL: "#" },
        { text: "Apple Store App", URL: "#" },
        { text: "Refurbished and Clearance", URL: "#" },
        { text: "Financing", URL: "#" },
        { text: "Apple Trade In", URL: "#" },
        { text: "Order Status", URL: "#" },
        { text: "Shopping Help", URL: "#" },
      ],
    },
  ],
  [
    {
      title: "For Business",
      links: [
        { text: "Apple and Business", URL: "#" },
        { text: "Shop for Business", URL: "#" },
      ],
    },
    {
      title: "For Education",
      links: [
        { text: "Apple and Education", URL: "" },
        { text: "Shop for College", URL: "" },
      ],
    },
    {
      title: "For Healthcare",
      links: [
        { text: "Manage Your Apple ID", URL: "#" },
        { text: "Apple Store Account", URL: "#" },
        { text: "iCloud.com", URL: "#" },
      ],
    },
    {
      title: "For Government",
      links: [
        { text: "Apple and Education", URL: "" },
        { text: "Shop for College", URL: "" },
      ],
    },
  ],
  [
    {
      title: "Apple Values",
      links: [
        { text: "Find a Store", URL: "#" },
        { text: "Genius Bar", URL: "#" },
        { text: "Today at Apple", URL: "#" },
        { text: "Apple Camp+", URL: "#" },
        { text: "Find Trip", URL: "#" },
        { text: "Apple Store App", URL: "#" },
      ],
    },
    {
      title: "About Apple",
      links: [
        { text: "Find a Store", URL: "#" },
        { text: "Genius Bar", URL: "#" },
        { text: "Today at Apple", URL: "#" },
        { text: "Apple Camp+", URL: "#" },
        { text: "Find Trip", URL: "#" },
        { text: "Apple Store App", URL: "#" },
      ],
    },
  ],
];

export default footerDataCollections;
